module.exports = __webpack_public_path__ + "static/media/linh-portrait.ff890cd9.jpg";